export default "__VITE_ASSET__BWLG519P__"